import * as Sentry from '@sentry/vue'
import { ignoreErrors, processAPIEnv, SentryInitParameters } from '.'

export const sentryBrowserInit = (initParams: SentryInitParameters) => {
  //see: https://docs.sentry.io/platforms/javascript/guides/vue/
  Sentry.init({
    app: initParams.app,
    dsn: 'https://af37160758e4457f800a14484e39f520@o1065306.ingest.sentry.io/4504476606070784',
    // This sets the sample rate to be 5%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.05,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 0.5,
    integrations: [
      Sentry.replayIntegration({
        // Additional SDK configuration goes in here, for example:
        maskAllText: false,
        blockAllMedia: false,
      }),
      Sentry.browserTracingIntegration(),
    ],
    tracesSampler: (samplingContext) => {
      if (process.env.API_URL && processAPIEnv(process.env.API_URL) == 'production') {
        return 0.25
      }
      // Sample 20% in testing envs
      return 1.0
    },
    maxValueLength: 10000,
    normalizeDepth: 5,
    environment: process.env.API_URL ? processAPIEnv(process.env.API_URL) : 'development',
    ignoreErrors: ignoreErrors,
  })

  Sentry.setContext('user info', {
    status: 'Not logged in yet',
  })
}
